import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';
import { getAuth, onAuthStateChanged, signInWithCustomToken } from 'firebase/auth';
import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios';
import { USER_GET_CUSTOM_TOKEN } from '@/assets/config/api.config';

const routes = [
  {
    path: '/',
    name: 'home',
    // Usa `beforeEnter` per eseguire un redirect a un dominio esterno
    beforeEnter() {
      if (window.location.search.includes('mode=resetPassword')) {
        window.location.href = 'https://app.cosmicup.me/reset-password' + window.location.search;
      } else if(window.location.search.includes('mode=verifyEmail')) {
        // go to current mail url, add '/tool' and window location search
        window.location.href = window.location.origin + '/tool' + window.location.search;
      } else {
        window.location.href = window.location.origin + '/login';
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/tool',
    name: 'tool',
    component: () => import('../views/ToolView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/chatgpt',
    name: 'chatgpt',
    beforeEnter() {
      window.location.href = 'https://app.cosmicup.me/tool';
    }
  },
  {
    path: '/claude',
    name: 'claude',
    beforeEnter() {
      window.location.href = 'https://app.cosmicup.me/tool';
    }
  },
  {
    path: '/gpt-chat',
    name: 'gpt-chat',
    component: () => import('../views/LandingChatView.vue')
  },
  {
    path: '/landing-tool',
    name: 'landing-tool',
    component: () => import('../views/LandingToolView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  logEvent(analytics, 'page_view', {
    page_path: to.fullPath,
    page_title: to.name || 'unknown', // Usa il nome della route o imposta un valore di default
  });
  if(to.path === '/reset-password' || 
    (to.path === '/' && !window.location.search.includes('mode')) || 
    to.path === '/login'
  ){
    const auth = getAuth();
    const user = await new Promise((resolve) => {
      onAuthStateChanged(auth, (currentUser) => resolve(currentUser));
    });
    if(user){
      next('/tool');
    } else {
      if (to.path !== '/reset-password' && window.WTN && (window.WTN.isAndroidApp || window.WTN.isIosApp)) {
        next('/landing-tool');
      } else {
        next();
      }
    }
  } else if (to.path === '/tool') {
    const auth = getAuth();
    const user = await new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
        unsubscribe();
        resolve(currentUser);
      });
    });

    if (user) {
      next();
    } else {
      if (window.WTN && (window.WTN.isAndroidApp || window.WTN.isIosApp)) {
        next('/landing-tool');
        return;
      }
      try {
        const customToken = await axios.get(USER_GET_CUSTOM_TOKEN, {
            withCredentials: true
        });
        if (customToken && customToken.data && customToken.data.customToken) {
             await signInWithCustomToken(auth, customToken.data.customToken);
             next();
        } else {
            next('/login');
        }
      } catch (error) {
        next('/login');
      }
    }
  } else {
    next();
  }
});

export default router
